<template>
    <div v-if="task.can_add_dependency">
        <select-input
            v-model="localValue"
            name="task_template_parent_id"
            :options="taskTemplateAvailableParents"
            placeholder="Välj beroende"
        />

        <button
            v-if="task.task_template_parent_id"
            class="mt-sm"
            type="button"
            @click.prevent="localValue = ''"
        >
            <font-awesome-icon icon="times" class="text-danger" />
            Ta bort beroende
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                required: false,
                type: String,
                default: '',
            },
            taskListTemplate: {
                type: Object,
                required: true,
            },
            task: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                localValue: this.value || '',
            };
        },
        computed: {
            taskTemplateAvailableParents() {
                const tasks = {};

                this.taskListTemplate.tasks.forEach(task => {
                    if (task.id === this.task.id) {
                        return;
                    }

                    tasks[task.id] = task.body;
                });

                return tasks;
            },
        },
        watch: {
            localValue(newValue) {
                this.$emit('input', newValue);
            },
        },
    };
</script>